// @ts-nocheck
export const localeCodes =  [
  "cs",
  "sk",
  "de_DE",
  "hu_HU",
  "pl_PL",
  "en"
]
export const localeLoaders = {
  cs: [],
  sk: [],
  de_DE: [],
  hu_HU: [],
  pl_PL: [],
  en: []
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/8dc0f223" /* webpackChunkName: "config_nuxt_45i18n_46ts_8dc0f223" */)
]
export const normalizedLocales = [
  {
    code: "cs",
    language: "cs"
  },
  {
    code: "sk",
    language: "sk"
  },
  {
    code: "de_DE",
    language: "de"
  },
  {
    code: "hu_HU",
    language: "hu"
  },
  {
    code: "pl_PL",
    language: "pl"
  },
  {
    code: "en",
    language: "en"
  }
]
/** client **/

/** client-end **/